import React, { useEffect, useMemo, useState } from 'react';
// import { useDispatch } from "react-redux";
import { ntxAPI } from '../../API/axiosNeatex';
// import { useAppDispatch } from "../../store/hooks";
import DoughnutChart from './ChartJS/DoughnutChart';
// import { Card } from "../../components/card/card";
import RadialBarChart from './ApexchartsJS/RadialBarChart';
import PieChart from './ChartJS/PieChart';
// import PieChartApex from "./ApexchartsJS/PieChart";
import BarChart from './ChartJS/BarChart';
import AreaChart from './ApexchartsJS/AreaChart';
import ColumnChart from './ApexchartsJS/ColumnChart';
import RadarChart from './ChartJS/RadarChart';
import RadarChartApex from './ApexchartsJS/RadarChart';
import LineChart from './ChartJS/LineChart';
import TableChart from './TableChart/TableChart';
import ReportTable from '@pages/NTX/Reports/ReportsModule/ReportsBuilder2/ReportTable';

interface Props {
  chartId: string;
  DataChartReport?: Record<string, any>;
  chartDateFrom?: string;
  chartDateTo?: string;
}

const RenderChart: React.FC<{ chartType: string; data: any }> = ({ chartType, data }) => {
  switch (chartType) {
    case 'donut':
      return <DoughnutChart data={data} />;
    case 'pie':
      return <PieChart data={data} />;
    case 'radialBar':
      return <RadialBarChart data={data} />;
    case 'bar':
      return <BarChart data={data} />;
    // return <TableChart data={data} />;
    case 'area':
      return <AreaChart data={data} />;
    case 'column':
      return <ColumnChart data={data} />;
    // return <TableChart data={data} />;
    case 'radar':
      return <RadarChartApex data={data} />;
    case 'line':
      return <LineChart data={data} />;
    case 'table':
      return <TableChart data={data} />;  
     default:
      return null;
  }
};

const Index: React.FC<Props> = ({ chartId, chartDateFrom, chartDateTo, DataChartReport }) => {
  const [chartdata, setChartdata] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;

    async function fetchData() {
      setIsLoading(true);
      setIsError(false);

      try {
        const { data } = await ntxAPI.post('Reports/GetReportsChartData', {
          reportChartId: chartId,
          parameterList: [],
          chartDateFrom: chartDateFrom || null,
          chartDateTo: chartDateTo || null
        });

        if (isMounted) {
          if (data?.succeeded === false) {
            setIsError(true);
          } else {
            // console.log(JSON.stringify(data));

            setChartdata(data.data);
          }
        }
      } catch (error) {
        if (isMounted) {
          console.error('Error fetching data:', error);
          setIsError(true);
        }
      } finally {
        if (isMounted) setIsLoading(false);
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [chartId, chartDateFrom, chartDateTo]);

  const chart = useMemo(() => {
    if (isLoading) {
      return (
        <div className='text-center h-100' style={{ paddingTop: '7rem' }}>
          <div className='spinner-grow text-success'></div>
          <div className='spinner-grow text-danger'></div>
          <div className='spinner-grow text-warning'></div>
        </div>
      );
    }

    if (isError) {
      return (
        <div className='text-center h-100' style={{ paddingTop: '7rem' }}>
          <div className='text-theme'>Error fetching data. Please try again.</div>
          <button
            onClick={() => window.location.reload()} // أو يمكنك استدعاء fetchData مباشرة
            className='btn btn-primary mt-3'
          >
            Retry
          </button>
        </div>
      );
    }

    if (!chartdata) {
      return (
        <div className='text-center h-100' style={{ paddingTop: '7rem' }}>
          <div className='text-theme'>No data available to display.</div>
        </div>
      );
    }

    return <RenderChart chartType={chartdata.chartType} data={chartdata} />;
  }, [isLoading, isError, chartdata]);

  return <>{chart}</>;
};

export default Index;
